import { Reveal, Eyebrow } from "../Bits";

const BrandStatement = () => (
  <section data-testid="home-brand-statement" className="bg-white py-24 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <Reveal>
        <Eyebrow>MAKO Mats</Eyebrow>
        <h2 className="mt-8 max-w-5xl font-display text-4xl font-bold uppercase leading-[0.96] tracking-[-0.02em] text-[#111111] sm:text-5xl lg:text-[5.25rem]">
          A new standard for
          <span className="block text-[#7A7F85]">combat surfaces.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="mt-14 grid gap-10 border-t border-[#111111]/10 pt-10 lg:grid-cols-12">
          <p className="mako-label lg:col-span-4 text-[#0F4C81]">Built for impact.</p>
          <p className="max-w-2xl text-sm leading-relaxed text-[#3B3B3B] sm:text-base lg:col-span-8">
            Modern products. Professional presentation. Built for the growth of combat sport in
            India.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default BrandStatement;
